export default (props) => (
  <svg
    width="25"
    height="21"
    viewBox="0 0 25 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.1124 2.72656C15.2087 2.5599 15.4492 2.55989 15.5454 2.72656L22.016 13.9338C22.1122 14.1005 21.9919 14.3088 21.7994 14.3088H8.85841C8.66597 14.3088 8.54568 14.1005 8.64191 13.9338L15.1124 2.72656Z"
      stroke="#bec8df"
      strokeWidth="1.5"
      fill="#BEC7DC"
    />
    <rect
      x="1.62793"
      y="8.53125"
      width="12.4441"
      height="11.5145"
      rx="1.25"
      stroke="#bec8df"
      strokeWidth="1.5"
      fill="#BEC7DC"
    />
  </svg>
);
